import { render, staticRenderFns } from "./ModalAddCharacteristic.vue?vue&type=template&id=2b84fd96"
import script from "./ModalAddCharacteristic.vue?vue&type=script&lang=js"
export * from "./ModalAddCharacteristic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports